import { CustomersPriceTablesDto } from '@tiendanube/common';

export enum statusType {
  idle = 'idle',
  loading = 'loading',
  error = 'error',
  success = 'success',
}

export interface CustomerPriceTablesInterface {
  priceTables: {
    data: CustomersPriceTablesDto[];
    status: statusType;
  };
}
